import { IoPaperPlane } from "react-icons/io5";
import { useEffect, useRef } from "react";
import { Agent } from "types";
import { AgentStatus } from "constants/agents";

export const MessageInput: React.FC<{
  scrollToBottom: () => void;
  inputMessage: string;
  setInputMessage: (message: string) => void;
  sendMessage: () => Promise<void>;
  isSending: boolean;
  currentAgent?: Agent;
}> = ({
  inputMessage,
  setInputMessage,
  sendMessage,
  isSending,
  scrollToBottom,
  currentAgent,
}) => {
  const inputRef = useRef<HTMLInputElement>(null);

  useEffect(() => {
    inputRef.current?.focus();
    inputRef.current?.select();
  }, []);

  const handleSendMessage = async () => {
    setTimeout(() => scrollToBottom(), 100);
    await sendMessage();
    inputRef.current?.focus();
  };

  const isButtonDisabled =
    isSending ||
    !currentAgent ||
    currentAgent?.is_archived ||
    currentAgent?.status !== AgentStatus.READY;

  return (
    <div className="absolute bottom-4 left-0 mt-6 flex w-full items-center gap-2 px-6">
      <div className="flex h-[50px] w-full items-center rounded-full bg-gray-100 px-5 pr-3 dark:bg-navy-700">
        <input
          ref={inputRef}
          placeholder={
            !currentAgent
              ? "Please select an agent to start chatting"
              : isButtonDisabled
              ? "This agent is not available to chat"
              : "Type your message..."
          }
          className="h-full w-full rounded-full bg-gray-100 px-2 text-sm text-gray-800 placeholder-gray-500 outline-none dark:bg-navy-700 dark:text-white dark:placeholder-gray-400"
          type="text"
          value={inputMessage}
          onChange={(e) => setInputMessage(e.target.value)}
          onKeyDown={(e) => {
            if (e.key === "Enter" && !e.shiftKey) {
              e.preventDefault();
              handleSendMessage();
            }
          }}
          disabled={isButtonDisabled}
        />
      </div>

      <button
        onClick={handleSendMessage}
        disabled={isButtonDisabled}
        className="linear flex items-center justify-center rounded-full bg-blue-500 p-3 text-base text-white transition duration-200 hover:cursor-pointer hover:bg-blue-600 active:bg-blue-700 disabled:cursor-not-allowed disabled:opacity-50 dark:bg-blue-600 dark:hover:bg-blue-700 dark:active:bg-blue-800"
      >
        {isSending ? (
          <div className="h-4 w-4 animate-spin rounded-full border-b-2 border-white dark:border-b-gray-200"></div>
        ) : (
          <IoPaperPlane className="text-white dark:text-gray-200" />
        )}
      </button>
    </div>
  );
};
